import http from '../http'

const API_URL = "identification_type"

class IDTypeAPI {

  async getIDTypes() {
    const response = await http(`${API_URL}`, 'GET')
    return response || null
  }

}

export default new IDTypeAPI()